import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import translationEn from "../public/locales/en/translation.json";
import translationSv from "../public/locales/sv/translation.json";

import startEn from "./locales/pages/en/start.json";
import startSv from "./locales/pages/sv/start.json";
import investEn from "./locales/pages/en/invest.json";
import investSv from "./locales/pages/sv/invest.json";
import termsSv from "./locales/pages/sv/terms.json";
import termsEn from "./locales/pages/en/terms.json";
import aboutSv from "./locales/pages/sv/about.json";
import aboutEn from "./locales/pages/en/about.json";
import contactformSv from "./locales/components/sv/contactform.json";
import contactformEn from "./locales/components/en/contactform.json";
import faqSv from "./locales/components/sv/faq.json";
import faqEn from "./locales/components/en/faq.json";

i18n
  .use(initReactI18next) // Passes i18n down to react-i18next
  .use(LanguageDetector) // Detects user language
  .init({
    resources: {
      en: {
        start: startEn,
        invest: investEn,
        terms: termsEn,
        contactform: contactformEn,
        faq: faqEn,
        about: aboutEn,
        translation: translationEn, // Common strings
      },
      sv: {
        start: startSv,
        invest: investSv,
        terms: termsSv,
        contactform: contactformSv,
        faq: faqSv,
        about: aboutSv,
        translation: translationSv, // Common strings
      },
    },
    supportedLngs: ["en", "sv"], // Supported languages
    fallbackLng: "en", // Fallback language
    ns: [
      "translation",
      "start",
      "invest",
      "terms",
      "faq",
      "contactform",
      "about",
    ], // Namespaces
    defaultNS: "translation",
    detection: {
      order: [
        "querystring",
        "cookie",
        "localStorage",
        "sessionStorage",
        "navigator",
        "htmlTag",
        "path",
        "subdomain",
      ],
      caches: ["localStorage", "cookie"],
      cookieOptions: {
        path: '/',
        domain: window.location.hostname.includes('tuutuum.se') 
          ? '.tuutuum.se' 
          : window.location.hostname,
        sameSite: 'lax'
      }
    },
    interpolation: {
      escapeValue: false,
    },
    react: {},
    debug: true,
  });

export default i18n;
